import { useEffect, useState } from 'react'

export const useConsent = () => {
  const [consent, setConsent] = useState<'ask' | 'given' | 'using'>(
    () =>
      (sessionStorage.getItem('userHasConsented') as
        | 'ask'
        | 'given'
        | 'using') || 'ask',
  )

  useEffect(() => {
    const handleStorageChange = (event: StorageEvent) => {
      if (event.key === 'userHasConsented' && event.newValue) {
        setConsent(event.newValue as 'ask' | 'given' | 'using')
      }
    }
    window.addEventListener('storage', handleStorageChange)
    return () => window.removeEventListener('storage', handleStorageChange)
  }, [])

  const updateConsent = (newConsent: 'ask' | 'given' | 'using') => {
    sessionStorage.setItem('userHasConsented', newConsent)
    setConsent(newConsent)
    window.dispatchEvent(
      new StorageEvent('storage', {
        key: 'userHasConsented',
        newValue: newConsent,
      }),
    )
  }

  return [consent, updateConsent] as const
}
